module.exports = __webpack_public_path__ + "static/img/3.3c202d9d.jpg";